import React from 'react'
import './skills.css'

export default function Frontend() {
  return (
    <div className="skills__content">
        <h1 className="skills__title">Frontend Developer</h1>
        <div className="frontend">
             <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i class="uil uil-html5" style={{color:"Green",fontSize:"55px"}}></i>
                </div>
                <h3 className="skills__name">HTML5</h3>
                <span className="skills__level">Advanced</span>
            </div>
        </div>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i class="uil uil-css3-simple"style={{color:"Green",fontSize:"55px"}}></i>
                </div>
                <h3 className="skills__name">CSS</h3>
                <span className="skills__level">Advanced</span>
            </div>
        </div>
        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                   <i class="uil uil-java-script"style={{color:"gold",fontSize:"55px"}}></i>
                </div>
                <h3 className="skills__name">JavaScript</h3>
                <span className="skills__level">Advanced</span>
            </div>
        </div>
          <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i className='bx bx-badge-check'style={{color:"Green",fontSize:"55px"}}></i>
                </div>
                <h3 className="skills__name">Bootstrap</h3>
                <span className="skills__level">intermidate</span>
            </div>
        </div>
          <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i className='bx bx-badge-check'style={{color:"dodgerBlue",fontSize:"55px"}}></i>
                </div>
                <h3 className="skills__name">TailWind</h3>
                <span className="skills__level">Advanced</span>
            </div>
        </div>
          <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                   <i class="uil uil-react"style={{color:"Blue",fontSize:"55px"}}></i>
                </div>
                <h3 className="skills__name">React.Js</h3>
                <span className="skills__level">Advanced</span>
            </div>
        </div>
          <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i className='bx bx-badge-check'style={{color:"dodgerBlue",fontSize:"55px"}}></i>
                </div>
                <h3 className="skills__name">TypeScript</h3>
                <span className="skills__level">Basic</span>
            </div>
        </div>
          <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                <i class="uil uil-code-branch"style={{color:"Navy",fontSize:"55px"}}></i>
                </div>
                <h3 className="skills__name">Git</h3>
                <span className="skills__level">intermidate</span>
            </div>
        </div>
          <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <i className='bx bx-badge-check'style={{color:"Green",fontSize:"55px"}}></i>
                </div>
                <h3 className="skills__name">Style Component</h3>
                <span className="skills__level">Advanced</span>
            </div>
        </div>

        </div>
        
    </div>
  )
}
